import React from "react";
import "./styles.css";
const CustomZoomControl = ({ zoom, onZoomChange }) => {
    return (
    //<MapControl position={ControlPosition.RIGHT_BOTTOM}>
    React.createElement("div", { className: "zoom-controls" },
        React.createElement("button", { type: "button", className: "btn btn-black", onClick: () => onZoomChange(zoom + 1) },
            " ",
            React.createElement("i", { className: "fa-regular fa-plus" }),
            " "),
        React.createElement("button", { type: "button", className: "btn btn-black", onClick: () => onZoomChange(zoom - 1) },
            " ",
            React.createElement("i", { className: "fa-regular fa-minus" }),
            " "))
    //</MapControl> 
    );
};
export default CustomZoomControl;
